module.exports = "/_next/static/images/game-1-phone-avatar-vanna-8204c473e4e2da6e950eb3d4c00484e3.jpg";